
import { useEffect, useState } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { MobileExitPopup } from "./exit-intent/MobileExitPopup";
import { DesktopExitPopup } from "./exit-intent/DesktopExitPopup";
import { trackExitIntent } from "@/utils/metaPixel";

export const ExitIntentPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isSliding, setIsSliding] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    let timeoutId: number;
    
    if (!isMobile) {
      // Desktop exit intent behavior
      const handleMouseLeave = (e: MouseEvent) => {
        if (e.clientY <= 0) {
          const hasSeenPopup = localStorage.getItem("hasSeenExitPopup");
          if (!hasSeenPopup) {
            timeoutId = window.setTimeout(() => {
              setIsVisible(true);
              localStorage.setItem("hasSeenExitPopup", "true");
              // Track exit intent popup viewed
              trackExitIntent('viewed');
            }, 500);
          }
        }
      };

      document.addEventListener("mouseleave", handleMouseLeave);
      return () => {
        document.removeEventListener("mouseleave", handleMouseLeave);
        clearTimeout(timeoutId);
      };
    } else {
      // Mobile behavior - show after 5 seconds if not previously dismissed
      const dismissedUntil = localStorage.getItem("popupDismissedUntil");
      const currentTime = new Date().getTime();
      
      if (!dismissedUntil || currentTime > parseInt(dismissedUntil)) {
        timeoutId = window.setTimeout(() => {
          setIsVisible(true);
          setIsSliding(true);
          // Track exit intent popup viewed on mobile
          trackExitIntent('viewed');
        }, 5000);
      }
    }

    return () => clearTimeout(timeoutId);
  }, [isMobile]);

  const handleDismiss = () => {
    setIsSliding(false);
    // Set dismissal for 30 days
    const dismissalTime = new Date().getTime() + (30 * 24 * 60 * 60 * 1000);
    localStorage.setItem("popupDismissedUntil", dismissalTime.toString());
    
    // Track exit intent popup dismissed
    trackExitIntent('dismissed');
    
    setTimeout(() => {
      setIsVisible(false);
    }, 300); // Match transition duration
  };

  if (isMobile) {
    return (
      <MobileExitPopup
        isVisible={isVisible}
        isSliding={isSliding}
        handleDismiss={handleDismiss}
      />
    );
  }

  return (
    <DesktopExitPopup
      isVisible={isVisible}
      onDismiss={() => setIsVisible(false)}
    />
  );
};
